import { DownOutlined } from '@ant-design/icons';
import { type MouseEvent, useRef } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import useDropdownStore from '@/stores/pure/DropdownStore';
import { FILTER_OPERATOR, getFilterOperatorText } from '@/types/dataTableConst';

import FilterItemOperatorSelectModal from './FilterItemOperatorSelectModal';

type Props = {
  dropdownKey: string;
  operator?: FILTER_OPERATOR;
  multiFilter: boolean; // 현재 선택된 값이 여러개인지
  isMultiValueField?: boolean; // 필드가 여러개 값을 가질 수 있는지
  onChange?: (value: FILTER_OPERATOR) => void;
};

const FilterItemOperatorSelector = (props: Props) => {
  const setCurrDropdown = useDropdownStore((state) => state.setCurrDropdown);
  const ref = useRef<HTMLDivElement>(null);

  const onClick = (e: MouseEvent) => {
    e.stopPropagation();
    if (props.onChange && props.multiFilter && props.isMultiValueField) {
      setCurrDropdown(props.dropdownKey);
    }
  };

  return (
    <>
      <Style onClick={onClick} ref={ref} g={8}>
        <Typo type="label3" ellipsis>
          {getFilterOperatorText({
            operator: props.operator || FILTER_OPERATOR.OR,
            multiFilter: props.multiFilter,
            isMultiValueField: props.isMultiValueField,
          })}
        </Typo>
        {props.multiFilter && <DownOutlined />}
      </Style>
      <FilterItemOperatorSelectModal
        anchorRef={ref}
        dropdownKey={props.dropdownKey}
        selected={props.operator || FILTER_OPERATOR.OR}
        onChange={props.onChange}
        multiFilter={props.multiFilter}
        multiValue={props.isMultiValueField}
      />
    </>
  );
};

const Style = styled(Flex)`
  color: ${(props) => props.theme.colors.gray500};
  align-items: center;
  height: 100%;
  background-color: transparent;
  transition: background-color 0.2s;
`;

export default FilterItemOperatorSelector;
